__turbopack_context__.v({
  "alert": "Alert-module__m6lsNq__alert",
  "alertDanger": "Alert-module__m6lsNq__alertDanger",
  "alertFlat": "Alert-module__m6lsNq__alertFlat",
  "alertInfo": "Alert-module__m6lsNq__alertInfo",
  "alertLimitedHeight": "Alert-module__m6lsNq__alertLimitedHeight",
  "alertLimitedPadding": "Alert-module__m6lsNq__alertLimitedPadding",
  "alertNote": "Alert-module__m6lsNq__alertNote",
  "alertSuccess": "Alert-module__m6lsNq__alertSuccess",
  "alertWarning": "Alert-module__m6lsNq__alertWarning",
  "alertWithDismiss": "Alert-module__m6lsNq__alertWithDismiss",
  "alert__dismiss": "Alert-module__m6lsNq__alert__dismiss",
});
